module.exports = __webpack_public_path__ + "static/media/置顶 (1).a155d5b9.svg";